import React from "react"
import ButnotP from "../Styles/butnotP"
import RedditTextField from "./reddit-textfield"
import '../Styles/PayPage.css'
import '../Styles/Debt_form.css'
import html2canvas from 'html2canvas'
import { FaDownload } from "react-icons/fa"
import { MdArrowBack } from "react-icons/md"
import { Form } from 'react-bootstrap';
import consentPdf from '../documents/Согласие_на_обработку_сгенерировать_квитанцию.pdf';

const INN='1831167427'
const Account='40702810568000021825'
const BIC='048073601'
const CorrAccount='30101810300000000601'
const KPP='183201001'
const Recipient='Общество с ограниченной ответственностью Профессиональная коллекторская организация "Экспресс Коллекшн"'
const Bank='БАШКИРСКОЕ ОТДЕЛЕНИЕ № 8598'

const requisites = {
  INN: INN,
  Account: Account,
  BIC: BIC,
  CorrAccount: CorrAccount,
  KPP: KPP,
  Recipient: Recipient,
  Bank: Bank,
}

const downloadImage = (blob, fileName) => {
  const fakelink = window.document.createElement('a')
  fakelink.style = 'display:none'
  fakelink.download = fileName
  fakelink.href = blob
  document.body.appendChild(fakelink)
  fakelink.click()
  document.body.removeChild(fakelink)
  fakelink.remove()
}

const handleCaptureClick = async (el, imageFileName) => {
  const canvas = await html2canvas(el);
  const dataURL = canvas.toDataURL('image/png', 1.0);
  downloadImage(dataURL, imageFileName);
};

const TableP = (props) => {
  const exportedRef = React.createRef()

  return <>
    <div
        ref={exportedRef}
        className='RequisitesTable'
        style={!props.hide
            ? { transform: 'translateX(120px)', opacity: 0, pointerEvents: 'none', transition: 'all 320ms cubic-bezier(0.4, 0, 0.2, 1) 0ms' }
            : { transform: 'translateX(0)', opacity: 1, pointerEvents: 'auto', transition: 'all 320ms cubic-bezier(0.4, 0, 0.2, 1) 320ms' }
        }
    >
      <div id='onetwo-one'>{requisites.Bank}</div>
      <p id='three-one'>БИК</p>
      <div id='four-one'>{requisites.BIC}</div>
      <div style={{display:'flex', flexDirection:'column'}} id='one-two'>
        <span>ИНН</span>
        <div>{requisites.INN}</div>
      </div>
      <div style={{display:'flex', flexDirection:'column'}} id='two-two'>
        <span>КПП</span>
        <div>{requisites.KPP}</div>
      </div>
      <p id='three-two'>К/сч</p>
      <div id='four-two'>{requisites.CorrAccount}</div>
      <div style={{display:'flex', flexDirection:'column'}} id='onetwo-three'>
        <span>Получатель</span>
        {requisites.Recipient}
      </div>
      <p id='three-three'>Р/сч</p>
      <div id='four-three'>{requisites.Account}</div>
      <div id='onefour-four'>{props.reqs}</div>
      {props.qr && <div id='five'>{props.qr}</div>}
    </div>
    <div
        className="flex-buttons"
        style={!props.hide
            ? { transform: 'translateX(120px)', opacity: 0, pointerEvents: 'none', transition: 'all 320ms cubic-bezier(0.4, 0, 0.2, 1) 100ms' }
            : { transform: 'translateX(0)', opacity: 1, pointerEvents: 'auto', transition: 'all 320ms cubic-bezier(0.4, 0, 0.2, 1) 100ms' }
        }
    >
      <button
          name='payback'
          id='ButtonPayBack'
          onClick={props.handleClick}
      >
        <MdArrowBack style={{marginRight:'2px', paddingBottom:'2px', scale:'1.25'}}/> Создать новую квитанцию
      </button>
      <button
          onClickCapture={() => handleCaptureClick(exportedRef.current, 'Реквизиты Экспресс Коллекшн')}
          name='download'
          id='ButtonDownload'
          onClick={props.handleCaptureClick}
      >
        Скачать квитанцию <FaDownload style={{marginLeft:'3px', paddingBottom:'1px'}}/>
      </button>
    </div>
  </>
}

const FormP = ({handleSubmit, hide, userdata, handleChange}) => {
  const [checked, setChecked] = React.useState(false)
  const [error, setError] = React.useState('')

  const handleSubmitWithCheck = (e) => {
    e.preventDefault()
    if (!checked) {
      setError('Необходимо дать согласие на обработку персональных данных')
      return
    }
    setError('')
    handleSubmit(e)
  }

  return (
      <div
          className='formGroupD'
          id='paypage'
          style={hide ? {
            transform: 'translateX(-120px)',
            opacity: 0,
            pointerEvents: 'none',
            transition: 'all 320ms cubic-bezier(0.4, 0, 0.2, 1)'
          } : {
            transform: 'translateX(0)',
            opacity: 1,
            pointerEvents: 'auto',
            transition: 'all 320ms cubic-bezier(0.4, 0, 0.2, 1) 320ms'
          }}
      >
        <label className='FormLabel' id='FormLabelP'>Сгенерируйте квитанцию на погашение задолженности</label>
        <form className='ECformD' onSubmit={handleSubmitWithCheck}>
          <div>
            <RedditTextField id='name' type='text' label='ФИО полностью' required variant='filled' name='name'
                             InputLabelProps={{shrink: true}} value={userdata.name} onChange={handleChange}/>
          </div>
          <div>
            <RedditTextField id='date' label='Дата рождения' required type='date' InputLabelProps={{shrink: true}}
                             variant='filled' name='date' value={userdata.date} onChange={handleChange}
                             InputProps={{disableUnderline: true}} inputProps={{min: "1950-05-01", max: "2023-05-04"}}/>
          </div>
          <div>
            <RedditTextField variant='filled' type='text' name='dogovor' InputLabelProps={{shrink: true}}
                             label='Номер кредитного договора' value={userdata.dogovor} onChange={handleChange}
                             id='dogovor'/>
          </div>
          <ButnotP type='submit' id='ButnotP2' name='Продолжить'
                   style={{width: '200px', height: '59px', fontSize: '12pt', borderRadius: '5px'}}/>
        </form>
        <div style={{marginTop: '8px', alignSelf: 'flex-start'}}>
          <Form.Check type='checkbox' id='check-api-consent-pay' style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
            <Form.Check.Input
                type='checkbox'
                id='check-api-pay'
                defaultChecked={checked}
                onClick={() => { setChecked(!checked); setError('') }}
                isValid
                style={{maxWidth: '24px', maxHeight: '24px', marginTop: '0px'}}
            />
            <Form.Check.Label style={{display: 'flex', alignItems: 'center', marginBottom: 0}}>
            <span className="Policy" onClick={() => window.open(consentPdf, '_blank')}>
              Я даю согласие на обработку персональных данных
            </span>
            </Form.Check.Label>
          </Form.Check>
          {error && <span style={{color: 'hsl(4 90% 58% / 0.7)', fontSize: 'small', fontWeight: 500}}>{error}</span>}
        </div>
      </div>
  )
}

export default React.memo(function TwoStep({
                                             hide, handleChange, handleSubmit, userdata, reqs, handleClick, qr, handleCaptureClick
                                           }) {
  return (
      // Обёртка с position: relative — внутри неё FormP и TableP абсолютно позиционированы
      // когда hide=false — показана форма, когда hide=true — показана таблица
      // Высота обёртки управляется классом twoStepWrapper
      <div className="twoStepWrapper">
        {!hide && (
            <FormP
                hide={hide}
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                userdata={userdata}
            />
        )}

        {hide && (
            <TableP
                qr={qr}
                hide={hide}
                requisites={requisites}
                handleClick={handleClick}
                reqs={reqs}
                handleCaptureClick={handleCaptureClick}
            />
        )}
      </div>
  )
})